import { useEffect } from 'react';
import { useHistory } from 'react-router';
import qs from 'qs';

import { useHttpGetAndCache } from '@common/hooks/use-http-get-and-cache';
import { V2_ROUTE_PAGES } from '@aware/v2-routes/constants';
import { getReportMapForGroup } from './helpers';

export const useLoadReportData = tabId => {
  const { data: { ReportGroups: rawReportsByGroup = [] } = {}, isLoading } =
    useHttpGetAndCache({
      url: `/aware/Reports/API/SerializedReportsByTab.aspx?tab=${tabId}`
    });

  const { reportsByGroup, reportsMap } = rawReportsByGroup.reduce(
    (acc, { GroupTitle, ReportMembers }, idx) => {
      return {
        ...acc,
        reportsByGroup: {
          ...acc.reportsByGroup,
          [GroupTitle]: {
            order: idx + 1,
            title: GroupTitle,
            reports: getReportMapForGroup(ReportMembers)
          }
        },
        reportsMap: { ...acc.reportsMap, ...getReportMapForGroup(ReportMembers) }
      };
    },
    { reportsMap: {}, reportsByGroup: {} }
  );

  return { isLoading, reportsByGroup, reportsMap };
};

export const useAddNavigationCallback = () => {
  const history = useHistory();
  useEffect(() => {
    window.top.navigateToReport = (path, params) => {
      history.push(
        `${V2_ROUTE_PAGES.analysisReports}/${path}${qs.stringify(params, { addQueryPrefix: true })}`
      );
    };
    return () => delete window.top.navigateToReport;
  }, [history]);
};
